import React from "react";

//Panels
import { ViewPavers } from "../../../../CTA/CTA";

//Images
import feature from "../../images/team/team-feature.jpg";
import apprenticeship1 from "../../images/staff-training/mortarboard.svg";
import apprenticeship2 from "../../images/staff-training/check.svg";
import apprenticeship3 from "../../images/staff-training/handyman-tools.svg";
import apprenticeship4 from "../../images/staff-training/contract.svg";

import crew from "../../images/staff-training/crew.jpg";
import moisture from "../../images/staff-training/water-drop.svg";
import thickness from "../../images/staff-training/wave.svg";
import compactor from "../../images/staff-training/truck.svg";
import drainage from "../../images/staff-training/drain.svg";
import walls from "../../images/staff-training/brickwall.svg";
import steps from "../../images/staff-training/stairs.svg";
import fire from "../../images/staff-training/bonfire.svg";

//SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";

const Team = () => {
  return (
    <>
      <SEO
        title="About Us | Our Team | Pacific Pavingstone"
        description="Learn more about Pacific Pavingstone and the professionally trained crew behind our work. Ready to get started on your next project? Contact us today?"
        profileURL={"https://www.pacificpavingstone.com/about-us"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          Image:
            "https://www.pacificpavingstone.com/static/media/team-feature.b72a44ee.jpg",
          significantLink: "https://www.pacificpavingstone.com/reviews",
        }}
      />
      <div className="row justify-content-center page-team">
        <div className="col-11 col-xl-10">
          <div className="row justify-content-center panel-content">
            <div className="col-md-6 col-lg-6">
              <img src={feature} alt="Feature" />
            </div>
            <div className="col-md-6 col-lg-6">
              <h3 className="text-blue text-uppercase mt-3 mt-md-0">
                A Family Business
              </h3>
              <p className="mt-lg-5">
                Terry Morrill, along with his sons Trent and Chad, are the
                owners of Pacific Outdoor Living, the parent company of Pacific
                Pavingstone, California Waterscapes, Jack’s Turf and Southern
                California Swimming Pools, located in Sun Valley, California.
                <br />
                <br />
                Terry has been in the business as a general contractor for 35
                years and has an architecture degree from the University of
                California at San Luis Obispo.
              </p>

              <div className="quote-wrapper">
                <p>
                  &quot;It is our mission to put customers first and go the
                  extra mile to ensure that they are completely satisfied -
                  whatever it takes, no questions asked.&quot;
                  <br />- Terry Morril
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-around panel-content panel-record">
            <div className="col-md-4 col-lg-3">
              <h1>20</h1>
              <h4>Years of Business</h4>
            </div>
            <div className="col-md-4 col-lg-3">
              <h1>1m</h1>
              <h4>Sq Ft of Landscaping Mapped</h4>
            </div>
            <div className="col-md-4 col-lg-3">
              <h1>15k</h1>
              <h4>Homeowners Served</h4>
            </div>
          </div>
          <div className="row justify-content-center mt-5 mb-5 pb-5 panel-crew">
            <div className="col-12 col-md-5">
              <h3 className="text-uppercase text-blue">
                Our Professionally Trained Crews
              </h3>
              <p>
                We have established a complete apprenticeship program for all of
                our crews in paving stone, landscaping and masonry.
                <br />
                <br />
                The training our crews get is 5 times as thorough as the one you
                get with an{" "}
                <a className="text-blue" href="https://icpi.org/" target="_blank" rel="noreferrer">
                  ICPI (Interlocking Concrete Pavement Institute)
                </a>{" "}
                certificate and our crews need to pass with 100%, not 70%.
              </p>
            </div>
            <div className="col-12 offset-md-1 col-md-6">
              <img src={crew} alt="Crew" />
            </div>
          </div>
          <div className="row justify-content-center panel-apprenticeship">
            <div className="col-12 text-center text-uppercase">
              <h3 className="text-blue">
                Outline of our Apprenticeship Training
              </h3>
            </div>
            <div className="col-11 mt-5">
              <div className="row justify-content-center text-center text-uppercase">
                <div className="col-8 col-md-5 col-lg-3 mt-3">
                  <div className="image">
                    <img src={apprenticeship1} alt="Classroom Study" />
                  </div>
                  <h5>Classroom Study</h5>
                </div>
                <div className="col-8 col-md-5 col-lg-3 mt-3">
                  <div className="image">
                    <img src={apprenticeship2} alt="Test Drills" />
                  </div>
                  <h5>Drills to test their understanding</h5>
                </div>
                <div className="col-8 col-md-5 col-lg-3 mt-3">
                  <div className="image">
                    <img src={apprenticeship3} alt="Practical Drills" />
                  </div>
                  <h5>Practical Drills in the Field</h5>
                </div>
                <div className="col-8 col-md-5 col-lg-3 mt-3">
                  <div className="image">
                    <img src={apprenticeship4} alt="Final Test" />
                  </div>
                  <h5>Final Test</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt-5 panel-knowledge">
            <div className="col-12 text-uppercase text-center">
              <h3 className="text-blue">
                Our Crews have extensive knowledge in
              </h3>
            </div>
            <div className="col-12 text-center mt-5">
              <div className="row justify-content-center">
                <div className="col-8 col-md-2">
                  <div className="image">
                    <img src={moisture} alt="Checking Moisture Content" />
                  </div>
                  <p className="text-uppercase">Checking Moisture Content</p>
                </div>
                <div className="col-8 col-md-2">
                  <div className="image">
                    <img
                      src={thickness}
                      alt="Determining Thickness of the base"
                    />
                  </div>
                  <p className="text-uppercase">
                    Determining Thickness of the base
                  </p>
                </div>
                <div className="col-8 col-md-2">
                  <div className="image">
                    <img src={compactor} alt="The size of the compactor" />
                  </div>
                  <p className="text-uppercase">The size of the compactor</p>
                </div>
              </div>
              <div className="row justify-content-center mt-5">
                <div className="col-8 col-md-2">
                  <div className="image">
                    <img src={drainage} alt="Drainage" />
                  </div>
                  <p className="text-uppercase">Drainage</p>
                </div>
                <div className="col-8 col-md-2">
                  <div className="image">
                    <img src={walls} alt="Building Segmental Walls" />
                  </div>
                  <p className="text-uppercase">Building Segmental Walls</p>
                </div>
                <div className="col-8 col-md-2">
                  <div className="image">
                    <img src={steps} alt="Building Steps and retaining Walls" />
                  </div>
                  <p className="text-uppercase">
                    Building Steps and retaining Walls
                  </p>
                </div>
                <div className="col-8 col-md-2">
                  <div className="image">
                    <img src={fire} alt="Building Firepits" />
                  </div>
                  <p className="text-uppercase">Building Firepits</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ViewPavers />
    </>
  );
};

export default Team;
